(function() {

    'use strict';

    /*jshint unused:false */



    var VAST = SAPO.Project.Video.VAST;
    var XML2 = SAPO.Utility.XML2;



    var linearHandlers = [
        VAST.handlers.AdUnit,
        VAST.handlers.Html5Video,
        VAST.handlers.FlashVideo
    ];

    var nonLinearHandlers = [
        VAST.handlers.AdUnit,
        VAST.handlers.Flash,
        VAST.handlers.Image,
        VAST.handlers.Saw
    ];



    var xmlToString = function(el) {
        return (new XMLSerializer()).serializeToString(el);
    };

    var handle = function(item, isLinear, xmlEl) {
        var handlers = (isLinear ? linearHandlers : nonLinearHandlers);
        var handler, res;
        for (var i = 0, I = handlers.length; i < I; ++i) {
            handler = handlers[i];
            res = handler(item);
            if (res) {
                // console.log(item.type, 'handled by', handler.name || handler.toString());
                return res;
            }
        }
        //console.error(item.type, 'not handled');
        //console.error(item, 'not handled');
        //console.error('not handled:', xmlToString(xmlEl));
    };

    var generateLabeledWrapper = function(parentEl, labelText) {
        var labelEl = document.createElement('p');
        labelEl.appendChild( document.createTextNode(labelText) );
        var itemEl  = document.createElement('div');
        var topEl   = document.createElement('div');

        topEl.className   = 'item-wrapper';
        labelEl.className = 'label';

        topEl.appendChild(labelEl);
        topEl.appendChild(itemEl);
        parentEl.appendChild(topEl);

        return itemEl;
    };

    var unwindItems = function(results, res) {
        if (!res) { return; }
        if ('item' in res) {
            results.push(res);
        }
        else {
            for (var i = 0, I = res.length; i < I; ++i) {
                results.push(res[i]);
            }
        }
    };

    var forEach = function(arr, fn) {
        var i, I;
        for (i = 0, I = arr.length; i < I; ++i) {
            fn(arr[i], i, arr);
        }
    };

    var applyProperty = function(results, propName, propVal) {
        var fn = function(o) {
            o.item[propName] = propVal;
        };
        forEach(results, fn);
    };



    var VASTRun = function(vastRunCfg) {
        //vastXmlUrl, bestMF, bestNLs, bestCs, cb/


        // STATE + done result
        var parts = {
            triggeredErrors: [],
            linears:    [],
            nonLinears: [],
            companions: []
        };



        var vp = new VAST.VASTParser();

        vp.on('getDocument', function(xmlDocUrl) {
            // console.log('getDocument', xmlDocUrl);
        });

        vp.on('document', function(doc) {
            // console.log('document', doc);
        });

        vp.on('error', function(error) {
            parts.triggeredErrors.push(error);
        });



        vp.on('MediaFiles', function(mediaFilesEl, bag) { // linear videos or VPAID ad linear units
            // console.log('MediaFiles', mediaFilesEl);

            var mediaFileEl, mediaFileEls = XML2.getChildren(mediaFilesEl, 'MediaFile');
            var res, o, results = [];
            for (var i = 0, I = mediaFileEls.length; i < I; ++i) {
                try {
                    mediaFileEl = mediaFileEls[i];
                    o = VAST.parsers.MediaFile(mediaFileEl);
                    res = handle(o, true, mediaFileEl);
                    unwindItems(results, res);
                } catch (ex) {
                    // console.error( xmlToString(mediaFileEl) );
                    // console.error(ex);
                }
            }

            var item = vastRunCfg.bestMediaFile(results);

            if (I > 0 && !item) {
                parts.triggeredErrors.push({code:403, message:'no supported mime types for linear ad'});
            }

            if (!item) { return; }

            item.item.bag = bag;

            parts.linears.push(item);
        });




        vp.on('NonLinearAds', function(nonLinearAdsEl, bag) { // linear videos or VPAID ad linear units
            // console.log('NonLinearAds', nonLinearAdsEl);

            var staticResourceEl, staticResourceEls = XML2.getChildren(nonLinearAdsEl, 'StaticResource');
            var res, o, results = [];
            for (var i = 0, I = staticResourceEls.length; i < I; ++i) {
                try {
                    staticResourceEl = staticResourceEls[i];
                    o = VAST.parsers.StaticResource(staticResourceEl);
                    res = handle(o, false, staticResourceEl);
                    unwindItems(results, res);
                } catch (ex) {
                    // console.error( xmlToString(staticResourceEl) );
                    // console.error(ex);
                }
            }

            var results2 = vastRunCfg.bestNonLinears(results);

            if (I > 0 && results2.length === 0) {
                parts.triggeredErrors.push({code:503, message:'no supported mime types for nonlinear ad'});
            }

            applyProperty(results2, 'bag', bag);

            forEach(results2, function(res) { parts.nonLinears.push(res); });
        });

        vp.on('CompanionAds', function(companionAdsEl, bag) { // linear videos or VPAID ad linear units
            // console.log('CompanionAds', companionAdsEl);

            var staticResourceEl, staticResourceEls = XML2.getChildren(companionAdsEl, 'StaticResource');
            var res, o, results = [];
            for (var i = 0, I = staticResourceEls.length; i < I; ++i) {
                try {
                    staticResourceEl = staticResourceEls[i];
                    o = VAST.parsers.StaticResource(staticResourceEl);
                    res = handle(o, false, staticResourceEl);
                    unwindItems(results, res);
                } catch (ex) {
                    // console.error( xmlToString(staticResourceEl) );
                    // console.error(ex);
                }
            }

            var results2 = vastRunCfg.bestCompanions(results);

            if (I > 0 && results2.length === 0) {
                parts.triggeredErrors.push({code:604, message:'no supported mime types for companion ad'});
            }

            applyProperty(results2, 'bag', bag);

            forEach(results2, function(res) { parts.companions.push(res); });
        });



        vp.on('done', function(stuff) {
            //console.log('done', stuff);
            stuff.parts = parts;

            vastRunCfg.cb(null, stuff);
        });



        vp.getDocument( vastRunCfg.vastXmlUrl );
    };

    SAPO.Project.Video.VAST.VASTRun = VASTRun;

})();
